export default "__VITE_PUBLIC_ASSET__9aaaaf6c__"